module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0105.jpg?v=f2ea5a68";